import React from "react";
import "./Style.css";

const LimitsMessage = (props) => {
  return (
    <div className="limits-message">
      <label>* Limite máximo atual: R${props.limite}</label>
    </div>
  );
};

export default LimitsMessage;
